import React, { useState, useEffect } from "react";
import { CheckBadgeIcon, ChevronDoubleRightIcon } from "@heroicons/react/24/outline";
import { FormField } from "../../components/formElements/formField";
import Select from 'react-select'
import { useCSAMemberStore } from "../../dataStore/CSAMemberStore";
import { useCSATierStore } from "../../dataStore/CSATierStore";
import { useFarmStore } from "../../dataStore/FarmStore";
import { useOneOffStore } from "../../dataStore/OneOffStore";
import { SmallSectionLoader, MediumFormLoader } from "../../components/loaders";
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import dayjs from "dayjs";
import { Link } from "react-router-dom";

var advancedFormat = require('dayjs/plugin/advancedFormat');
dayjs.extend(advancedFormat);

export default function CSAOneOffPage() {
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [view, setView] = useState("DETAILS");

  const registerCSA = useOneOffStore((state) => state.register);
  
  const fetchFarms = useFarmStore((state) => state.fetchCSA);
  const farms = useFarmStore((state) => state.farms);
  const fetchTiersCSA = useCSATierStore((state) => state.fetchCSA);
  const tiers = useCSATierStore((state) => state.objects);
  const [address, setAddress] = useState('');
  const [registration, setRegistration] = useState({});
  const [formErrors, setFormErrors] = useState({
    name : false,
    email: false,
    phone: false,
    address: false,
    has: false
  });

  useEffect(() => {
    async function fetchFarmsAndTiers() {
      setLoading(true);

      await fetchFarms();
      await fetchTiersCSA();
    }

    if (!loaded && !Object.keys(farms).length && !Object.keys(tiers).length) fetchFarmsAndTiers();
  })

  useEffect(() => {
    async function fetchData() {
      const farm = farms.filter(f => f.details.name === "Vagabond Vege")[0]?._id;
      createNewRegistration(farm, tiers[Object.keys(tiers)[0]]);

      setLoaded(true);
      setLoading(false);
    }

    if (!loaded && Object.keys(farms).length && Object.keys(tiers).length) fetchData();
  }, [farms, tiers])

  function createNewRegistration(farm, tier) {
    setRegistration({
      farm: farm,
      email: "",
      name: "",
      address : "",
      phone : "",
      csa_tier : tier,
      subscription : {
        box_size : "SMALL",
        delivered : false,
        delivery_instructions : "",
        delivery_area : "PICKUP",
        salad_extra : false,
        is_discounted : false,
        payment_terms : "WEEKLY",
        payment_method : "GC",
      }
    });
  }

  function calcDate() {
    let thisDay = dayjs().day();
    let addition = 0;
    if (thisDay <= 3) {
      addition = (3 - thisDay) + 7;
    } else {
      addition = 10 - thisDay;
    }
    let nextWednesday = dayjs().add(addition,'days');

    return (
      <div>
        <p>We will be in touch to confirm payment details and delivery day. We expect to deliver your box on <b>{nextWednesday.format('ddd Do MMM')}</b></p>
      </div>
    )
  }

  function calcPrice() {
    let PRICE = registration.csa_tier?.price.basePrice || 0;
    let deliveryText = "Picked-Up: Free";
    if (registration.subscription.delivered) {
      if (registration.subscription.delivery_area === "WAIRARAPA") {
        PRICE += registration.csa_tier.price.deliveryPrice;
        deliveryText = "Delivered to Wairarapa: $7";
      } else if (registration.subscription.delivery_area === "WELLINGTON") {
        PRICE += 10;
        deliveryText = "Delivered to Wellington: $10";
      } else if (registration.subscription.delivery_area === "LOWER_HUTT") {
        PRICE += 10;
        deliveryText = "Delivered to Lower Hutt: $5";
      }
    }
    return (
      <div className="text-right">
        <label className="inline-block mb-1 text-sm font-medium text-gray-700">Price</label>
        <p>{`${registration.subscription.box_size} BOX: $${registration.csa_tier?.price.basePrice || 0}`}</p>
        <p>{deliveryText}</p>
        <p className="font-bold">{`Total: $${PRICE}`}</p>
      </div>
    )
  }
  
  function _dsObjToSelectArr(obj, labelKey) {
    let optionArray = [];
    for (let [optionId, option] of Object.entries(obj)) {
      optionArray.push(option)
    }
    return optionArray;
  }

  function Radicchio() {
    return (
      <div className="group">
        <svg viewBox="0 0 254.24 452.56">
          <path className="fill-emerald-600 opacity-80" d="M129.39,179.56c4.17-.46,6.11-.66,6.44-4.92a209.78,209.78,0,0,1,6.87-40.45,11.82,11.82,0,0,1,5.05-7.17c5.78-3.79,11.56-7.58,17.27-11.47a39.56,39.56,0,0,0,15.07-19.07c1.73-4.53.77-7.9-2.85-9.24-4.32-1.61-4.9,3.68-6.31,7.32-2.87,7.39-10,9.68-16.79,13.59a15,15,0,0,1-1.95.69c1.13-5.23,3.44-9.6,5.38-14.08,3.47-8,7.25-15.86,9.74-24.24,2-6.83,3.41-13.67.2-20.56-1.24-2.66.8-4,2.39-5.48a169.71,169.71,0,0,1,30.65-22.13,127.91,127.91,0,0,0,11-7.18c6.47-4.58,9.64-3.8,12.76,3.55a35.15,35.15,0,0,1,1.46,24.07c-3.91,13.44-1.55,26.29,5.61,37.65,13,20.68,13.25,42.22,7.09,64.73-2.55,9.31-6.73,18.28-6.22,28.27.38,7.62,5.57,15.26,9.72,21.63C258.7,220.81,255,248,245.82,276c-2.07,6.36-4.42,12.66-7,18.83-5.69,13.55-1.43,27.06,4.16,40.45,6.83,16.36,5.76,33.47,5.23,51-.49,15.93-3.12,31.63-11.43,45.77-.77,1.3-1.68,2.52-2.44,3.82-4.17,7.18-10.44,9.45-18.42,7.83a13,13,0,0,0-4-.64c-5.31.71-6.94-1.53-6.11-6.54a91.35,91.35,0,0,0-.06-28.49c-.74-5-2.1-10.57,1.73-13.79,8.31-7,15.49-13.44,17.88-24.22.21-1,.56-1.93.69-2.92.49-3.82,1.2-6.83-2.83-7.57s-6.55,1.28-7.26,5.22A34.29,34.29,0,0,1,204.67,385a7,7,0,0,1-1.18.93,5.14,5.14,0,0,1-1.36.16c-3.87-16.93-9.93-33.19-16.63-49.22-1.75-4.18-3.24-8.52-5.52-12.39-3.11-5.27-2.28-10,.2-15.11,4.37-9.07,8.12-18.36,14.54-25.88,8.15-9.56,16.5-18.37,18.91-30.61.74-3.73-.39-6.85-4.26-8-3.37-1-6.76.48-7.28,3.74-2.5,15.71-12,27.39-22,38.85A88.06,88.06,0,0,0,170,302c-3.42-7.6-6.44-14.23-9.39-20.88a394.59,394.59,0,0,1-16-41.23,12.13,12.13,0,0,1,.29-8.73c5.34-13.3,14.63-25.51,25.28-34.81,10.27-9,20.87-15.78,25.45-29.31,1.56-4.6,3-9.23,3-14.16,0-3.48-1.72-6.08-5.18-6.38s-4.56,4.89-4.81,8.42c-1.17,16.08-13.58,23.3-24.84,32.93-9.26,7.91-17.8,16.4-24.38,26.9-2.06-2.2-1.59-4.88-1.87-7.36-.3-2.66-.65-5.3-1-7.95-.55-4.58-.8-7.37-7.29-7.44C129.36,189.16,129.37,182.36,129.39,179.56Z" transform="translate(-100)"/>
          <path className="fill-[#a63375] opacity-90" d="M304.51,117.17c-6.77-3.43-12.78-6.42-15.43-13.73-1.34-3.71-1.8-6.44-6.37-4.85-3.79,1.31-3.94,2.8-2.14,7.5,3.32,8.7,7.34,15.18,15,20.26a105.88,105.88,0,0,0,9.62,6.23c5.07,2.61,7.19,6.76,8.21,12.13,2.87,15.21,4.77,30.51,3.87,46-.54,9.32-.33,23.69-3,33.61-8.94-11.2-8.29-3.28-16-14.37-1.54-2.2-15.35-19.48-16.33-22-1.4-3.52-2.27-6.48-6.2-5.07s-6.11-.83-5,2.83c1.8,6,5.45,10.92,9.34,15.74,7.1,8.82,15.93,16,23.1,24.78,4.52,5.54,7.29,10.76,3.44,17.84-2.35,4.32-1.57,8.37,3,11.13-.42,1-.84,2.09-1.27,3.14-4.74-.69-7.38,1.63-9.11,5.87-4.83,11.83-9.84,25.58-14.75,37.31-2-.43-5.75-2.7-6.47-3.76-2.17-3.23-1.81-1.65-4.9,0s-4,2.46-2.11,4.76c7.43,9.13,5.09,17.56-.28,26.49-3,5-6,12.61-9.13,17.87-3.08-12.06-11.66-24.62-10.26-37.75.71-6.65,3.56-14.4,5.91-20.35,8-20.24,12-40.13,10.1-61.83a78,78,0,0,0-11.8-35.12c-6.65-10.8-8.89-21.65-4.26-34.06a113.15,113.15,0,0,0,7.09-47.88c-.88-12.35-4.16-24.16-10.92-34.73-6.41-10-8.73-20.44-5.1-32.18,2.65-8.55,2-19.33.08-28.65,12.47,7.36,26.56,14.9,36.84,24.21,1.36,1.22,1.6,3.63,3.11,4.62,3.56,2.32,6.46,4.71,4.81,9.14-2.12,5.68-1.82,11.75,0,17.58,3.92,12.57,8.9,24.29,13.81,36.46,1.42,3.53,4.19,8,4.48,11.84Z" transform="translate(-100)"/>
          <path className="fill-black" d="M354.23,210.08c-1,61.51-11.85,121-37.21,177.37-6.29,14-13.84,27.29-23.66,39.16-13.34,16.13-30.31,25.17-51.44,25.48-13.8.21-27.7,1.43-41.36-1.16-19.75-3.76-34.21-15.44-45.4-31.71-17.46-25.37-28.39-53.67-36.87-83-13.47-46.52-19.81-94-18-142.49,1.44-38.21,7.81-75.43,25.85-109.75,16.09-30.59,38.58-55.22,69-72.22,3.91-2.18,7.47-5,11.19-7.47,5.86-3.95,12-5.7,18.78-2.44a4.42,4.42,0,0,0,4.22-.16c5.21-2.46,10.65-2.29,15.3.79,16.58,11,34.29,20.39,48.68,34.62C322.86,66.3,340,101.76,348,142.07A339.43,339.43,0,0,1,354.23,210.08ZM252.78,438.91c16.18-4.12,27.91-14.13,37.08-27.7a202.43,202.43,0,0,0,17-30.45c15.56-34.66,25-71.05,30.44-108.55,6-41.11,7-82.21-.32-123.25-5.52-30.86-16.33-59.54-35.77-84.54-1.44-1.85-2.91-3.66-5-6.32a31.61,31.61,0,0,0,2.73,12.34c4.9,12,10,23.91,14.83,35.92,18.92,46.74,20.69,94,4.18,141.8-1.5,4.33-3.49,7.57-8.71,7.09-4.54-2.76-5.32-6.81-3-11.13,3.85-7.08,1.08-12.3-3.44-17.84-7.17-8.78-16-16-23.1-24.78-3.89-4.82-7.54-9.74-9.35-15.74-1.1-3.66-.22-6.69,3.66-8.08s6.43.52,7.83,4a34.11,34.11,0,0,0,3.54,7.1c7.75,11.09,18.6,19.31,27.54,30.51,2.63-9.92,3.41-19.29,4-28.61.9-15.47-1-30.77-3.87-46-1-5.37-3.14-9.52-8.21-12.13a105.88,105.88,0,0,1-9.62-6.23c-7.66-5.08-13.68-11.56-17-20.26-1.8-4.7-.65-8.19,3.14-9.5,4.57-1.59,7,1.13,8.37,4.85,2.65,7.31,7.66,12.29,14.43,15.73l.35.22-.39-.17c-.29-3.89-2.06-7.31-3.48-10.84C295.66,94.24,289.68,82.52,285.76,70c-1.82-5.83-3.12-11.9-1-17.59,1.65-4.42.75-6.81-2.81-9.13a35.12,35.12,0,0,1-4.11-3.63C267.56,30.3,255.47,23.75,243,16.4c1.9,9.32,3.57,18.1.92,26.65-3.63,11.74-1.31,22.16,5.1,32.18,6.76,10.57,10,22.38,10.92,34.73a113.18,113.18,0,0,1-7.09,47.88c-4.63,12.4-2.39,23.26,4.26,34A82,82,0,0,1,268.91,228c1.88,21.7-2.12,42.59-10.1,62.83-2.35,5.95-5.2,11.7-5.91,18.35-1.4,13.13,6.18,23.69,9.26,35.75,3.09-5.26,5.12-10.86,8.13-15.87,5.36-8.93,7.71-17.36.28-26.49-1.87-2.3-1.08-6,2.11-7.76s6.12-1.36,8.3,1.86c.72,1.07,1.11,2.44,3.07,2.88,4.91-11.73,9.92-23.48,14.75-35.31,1.73-4.24,4.37-6.56,9.11-5.87,3.72,2.89,4.28,6.39,2.31,10.59-1.35,2.85-2.36,5.85-3.56,8.77C294,308.64,279,338.53,265.42,369c-2.84,5.05-5.5,10.06-5.8,16.14a175.23,175.23,0,0,1-2.18,19.77,90.3,90.3,0,0,1-13.26,34.74C247.49,440.84,250.08,439.3,252.78,438.91ZM130.89,188.81c6.38.07,6.63,4.83,7.17,9.38.31,2.63.65,5.26.95,7.9.27,2.47-1.19,6.12.84,8.31,6.48-10.43,15.88-19.86,25-27.73,11.08-9.56,21.32-19.71,22.47-35.69.25-3.51,3.18-5.69,6.7-5.38s5.08,2.88,5.1,6.34c0,4.9-1.42,9.5-3,14.06-4.5,13.44-14.94,22.2-25,31.11-10.49,9.24-19.62,19.38-24.88,32.59a12.2,12.2,0,0,0-.28,8.68,396.72,396.72,0,0,0,15.71,40.95c2.91,6.61,5.87,13.19,9.24,20.75a86.83,86.83,0,0,1,9.94-14.41c9.86-11.39,19.16-23,21.62-38.6.51-3.24,3.84-4.72,7.16-3.71,3.81,1.16,4.92,4.25,4.19,7.95a70.28,70.28,0,0,1-15.65,32.4c-6.32,7.47-13,14.71-17.26,23.73-2.45,5.12-3.26,9.77-.2,15,2.25,3.85,3.71,8.16,5.43,12.31,6.6,15.93,12.56,32.08,16.37,48.89.71-.07,1.08,0,1.33-.16a6.87,6.87,0,0,0,1.17-.92,34.19,34.19,0,0,0,11.11-20.12c.69-3.92,3.26-5.91,7.14-5.19s5.23,3.73,4.75,7.52c-.12,1-.47,1.93-.68,2.9-2.35,10.71-8.44,19.11-16.6,26-3.78,3.21-5.39,6.76-4.66,11.72a91.66,91.66,0,0,1,.06,28.3c-.82,5,.79,7.2,6,6.5a12.64,12.64,0,0,1,3.92.63c7.84,1.61,14-.64,18.12-7.77.75-1.3,1.65-2.5,2.4-3.8,8.18-14.05,10.76-29.65,11.25-45.46a121.78,121.78,0,0,0-9.08-50.64c-5.51-13.3-5.76-26.72-.16-40.18,2.56-6.13,4.87-12.38,6.9-18.7,9-27.89,8.75-54.85-7.73-80.42-4.08-6.33-5.25-13.92-5.63-21.49-.5-9.92,3.62-18.83,6.13-28.08,6.06-22.36,5.85-43.76-7-64.3-7.05-11.29-9.37-24-5.52-37.4a35.27,35.27,0,0,0-1.44-23.91c-3.07-7.31-6.19-8.08-12.55-3.53A125.22,125.22,0,0,1,201,22.31a166.34,166.34,0,0,0-30.17,22c-1.56,1.42-3.57,2.8-2.35,5.44,3.16,6.85,1.81,13.63-.19,20.43-2.46,8.32-6.17,16.13-9.59,24.07-1.91,4.45-4.18,8.79-5.3,14a13.61,13.61,0,0,0,1.92-.69c6.68-3.88,11.73-9.13,14.55-16.47,1.4-3.62,3.94-5.9,8.19-4.3,3.56,1.34,4.5,4.68,2.8,9.19A39.29,39.29,0,0,1,166,114.9c-5.63,3.86-11.31,7.62-17,11.39a11.69,11.69,0,0,0-5,7.13,209.83,209.83,0,0,0-6.76,40.18c-.33,4.23-2.23,6.42-6.34,6.87-4.92-.73-6-4-5.67-8.35a213.85,213.85,0,0,1,8.34-46c5.69-19.17,14.7-37,21.78-55.65,1.38-3.63,2.91-7.29,2.56-12.22-1.33,1.6-2.15,2.58-2.95,3.58-17.37,21.47-28.37,46-34.77,72.7C112.2,168,110.78,202,113,236.19c2.76,42.23,10.94,83.36,25.46,123.13,7.78,21.3,17.26,41.79,31.65,59.63a55.75,55.75,0,0,0,23.57,17.38,115.76,115.76,0,0,0,.84-24.22c-1.58-22.31-8-43.38-16.09-64-11.17-28.47-25.21-55.68-36.37-84.15-8.46-21.61-14.86-43.73-16.52-67C125.27,192.67,126.32,189.67,130.89,188.81Z" transform="translate(-100)"/>
        </svg>
      </div>
    );
  }

  function formError() {
    let errors = {
      name : false,
      email: false,
      phone: false,
      address: false,
      has: false
    }

    if (registration.name.length < 2) {
      errors.has = true;
      errors.name = true;
    }
    if (registration.phone.length < 7) {
      errors.has = true;
      errors.phone = true;
    }
    var mailformat = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
	  if(!mailformat.test(registration.email.toLowerCase())) {
		  errors.has = true;
      errors.email = true;
		}
    setFormErrors(errors);
    return errors.has;
  }

  async function renew() {
    if (formError()) return;
    setSaving(true);
    
    const id = await registerCSA(registration);
    
    setSaving(false);

    if (id) {
      setSuccess(true);
    } else {
      alert("An error has occured. Please try again");
    }
  }

  function onAddressChange(address) {
    setAddress(address);
    setRegistration({ ...registration, address : address.value.description });
  }

  function setTier(tier) {
    setRegistration({ ...registration, csa_tier : tier, subscription : { ...registration.subscription, box_size : tier.tierCode }})
  }

  function setCollection(method) {
    if (method === "PICKUP") {
      setRegistration({ ...registration, subscription : { ...registration.subscription, delivered : false, delivery_area : method }});
    } else {
      setRegistration({ ...registration, subscription : { ...registration.subscription, delivered : true, delivery_area : method }});
    }
  }
  function collectionClass(method) {
    if (method === registration.subscription.delivery_area) {
      return "mx-1 my-6 px-2 pb-2 rounded border-4 border-emerald-500 text-gray-700 cursor-pointer";
    } else {
      return "mx-1 my-6 px-2 pb-2 rounded border-2 border-slate-500 hover:border-blue-500 text-gray-700 cursor-pointer"
    }
  }

  function successView() {
    return (
      <div className="absolute inset-0 pt-10 pb-5 px-5 bg-slate-100 overflow-scroll">
        {(loading || saving) ? (<div className="fixed top-0 w-full z-50"><div className="barLoader"></div></div>) : <></>}

        <div className="relative lg:fixed lg:left-10 lg:top-10">
          <img 
            src="https://cdn.vagabondvege.nz/images/logo/logo_main.png" 
            className="max-w-[200px]"
            alt="Vagabond Vege logo. Linocut vegetables and the farm name" />
        </div>

        <div className="grid grid-cols-1 gap-10">
          {bannerMessage(true)}

          <div className="w-full md:w-[700px] relative place-self-center">
            <div className="relative card border border-green-600 shadow-md bg-white px-5 py-1">
              <h1 className="font-bold text-xl mb-3 text-emerald-600">Success!</h1>
              <p className="mb-3">Thank you, your order has been saved. Vagabond Vege will be in touch soon to confirm the delivery date and payment details.</p>
            </div>
          </div>
          
          <div className="w-full md:w-[700px] relative place-self-center flex items-center text-center flex-col py-1">
            <div className="w-5 h-auto">
              {Radicchio()}
            </div>
          </div>
          
        </div>
      </div>
    )
  }

  function detailsAndTier() {
    return (
      <>

      <div className="w-full md:w-[700px] relative place-self-center">
        <h1 className="font-serif text-sm ml-6 mb-1 font-bold text-gray-500">YOUR DETAILS</h1>
        <div className="relative card border border-emerald-400 shadow-md bg-white px-5 py-1">
          {(loading) ? (
          <div className="mx-2 my-4">
            <MediumFormLoader />
          </div>
          ) : (
          <>
          <div className="grid grid-cols-2 gap-4">
            <FormField 
              name="CSA_NAME"
              placeholder="Joe Bloggs"
              title="Your Name"
              label={true}
              value={registration.name}
              onChange={(e) => setRegistration({ ...registration, name : e.target.value})}
              disabled={saving}
              errorMessage="Valid Name Required"
              showError={formErrors.name}
            />
            <FormField 
              name="CSA_EMAIL"
              placeholder="something@something.com"
              title="Your Email"
              label={true}
              value={registration.email}
              onChange={(e) => setRegistration({ ...registration, email : e.target.value})}
              disabled={saving}
              errorMessage="Valid Email Required"
              showError={formErrors.email}
            />
            <FormField 
              name="CSA_PHONE"
              placeholder="020 123 4567"
              title="Your Phone Number"
              label={true}
              value={registration.phone}
              onChange={(e) => setRegistration({ ...registration, phone : e.target.value})}
              disabled={saving}
              errorMessage="Valid Phone Required"
              showError={formErrors.phone}
            />
            <></>
            <div className="col-span-2 mb-3">
              <label className="inline-block mb-1 text-sm font-medium text-gray-700">Address</label>
              <GooglePlacesAutocomplete
                selectProps={{
                  defaultInputValue: registration.address,
                  address: registration.address,
                  onChange: onAddressChange,
                  isDisabled: saving
                }}
              />
            </div>
          </div>
          </>)}
        </div>
      </div>

      <div className="w-full md:w-[700px] relative place-self-center">
        <h1 className="font-serif text-sm ml-6 mb-1 font-bold text-gray-500">Box Selection</h1>
        <div className="relative card border border-emerald-400 shadow-md bg-white px-5 py-1">
          {(!loaded || loading) ? (
          <div className="mx-2 my-4">
            <SmallSectionLoader />
          </div>) : (
          <>
          <div className="mb-2">
            <label className="inline-block mb-1 text-sm font-medium text-gray-700">Box Size</label>
            <Select 
              value={registration.csa_tier}
              options={_dsObjToSelectArr(tiers, "tierName")} 
              getOptionLabel={el => el.tierName}
              getOptionValue={el => el._id}
              onChange={setTier}
              isDisabled={saving}
            />
          </div>
          </>
          )}
        </div>
      </div>

      <div className="w-full md:w-[700px] relative place-self-center">
        <h1 className="font-serif text-sm ml-6 mb-1 font-bold text-gray-500">Pickup / Delivery</h1>
        <div className="relative card border border-emerald-400 shadow-md bg-white px-5 py-1">
          {(!loaded || loading) ? (
          <div className="mx-2 my-4">
            <SmallSectionLoader />
          </div>) : (
          <>
            <p className="mb-1 font-medium">We offer pickup or delivery of your Box. Please select your option below:</p>
            
            <div 
              className={collectionClass("PICKUP")}
              onClick={() => setCollection("PICKUP")}
            >
              <label className="mb-1 text-sm font-bold text-black">PICKUP (FREE)</label>
              <p className="text-inherit">Collect directly from the farm in Greytown between 3pm & 6:30pm on Wednesday's</p>
            </div>

            <div 
              className={collectionClass("WAIRARAPA")}
              onClick={() => setCollection("WAIRARAPA")}
            >
              <label className="mb-1 text-sm font-bold text-black">WAIRARAPA DELIVERY ($7)</label>
              <p className="text-inherit">Delivery to Greytown, Carterton, Martinborough & Featherston between 1pm & 6:30pm on Wednesday's</p>
            </div>

            <div 
              className={collectionClass("WELLINGTON")}
              onClick={() => setCollection("WELLINGTON")}
            >
              <label className="mb-1 text-sm font-bold text-black">WELLINGTON DELIVERY ($10)</label>
              <p className="text-inherit">Delivery to Wellington from Thorndon south to Miramar/Island Bay on Wednesday's from 5pm to 12am. Address must be accessible outside business hours.</p>
              <a className="text-orange-400 hover:text-orange-500 underline" href="https://www.google.com/maps/d/u/0/edit?mid=1763AlqnvjFp3Osiu5fOpTTw7hvtuwek&usp=sharing" target="_blank" rel="noreferrer">View Delivery Map</a>
            </div>

            <div 
              className={collectionClass("LOWER_HUTT")}
              onClick={() => setCollection("LOWER_HUTT")}
            >
              <label className="mb-1 text-sm font-bold text-black">LOWER HUTT PICKUP ($5/week)</label>
              <p className="text-inherit">
                $5 Delivery to <a className="underline text-orange-400 hover:text-orange-500" href="https://www.google.com/maps/place/Forage+Merchants+of+Wellington/@-41.2150814,174.8906204,17z/data=!3m1!4b1!4m6!3m5!1s0x6d38ab7d96e06819:0xff2cfa15d9f37931!8m2!3d-41.2150855!4d174.8931953!16s%2Fg%2F11n0fyhxtc?entry=ttu" target="_blank">Forage Merchants Lower Hutt</a>.
                Boxes will arrive between 1-3pm Wednesday (pick-up closing 4:30pm) and shares must be collected by 4pm Thursday. You will recieve a text when the boxes leave the farm.
              </p>
            </div>

            {(registration.subscription.delivered) ? (<>
            <div className="mb-2">
              <label className="inline-block mb-1 text-sm font-medium text-gray-700">Delivery Instructions</label>
              <textarea 
                className='py-2 px-2 pr-9 block w-full border border-gray-200 rounded-md text-xs focus:border-blue-500 focus:ring-blue-500' 
                value={registration.subscription.delivery_instructions}
                onChange={(e) => {setRegistration({ ...registration, subscription : { ...registration.subscription, delivery_instructions : e.target.value}})}}
                isDisabled={saving}
              />
            </div>
            </>) : (<></>)}
          </>
          )}
        </div>
      </div>

      <div className="w-full md:w-[700px] relative place-self-center">
        <h1 className="font-serif text-sm ml-6 mb-1 font-bold text-gray-500">CONFIRMATION</h1>
        <div className="relative card border border-emerald-400 shadow-md bg-white px-5 py-1">
          {(loading) ? (
          <div className="mx-2 my-4">
            <MediumFormLoader />
            <MediumFormLoader />
            <MediumFormLoader />
          </div>
          ) : (
          <>
          {calcDate()}
          {calcPrice()}
          <div className="mt-6 mb-3 flex items-center gap-3 p-0">
            <div className="flex-1"></div>
            {(formErrors.has)?(<label className="font-bold text-xs text-red-600">Please fill in all the required details</label>):(<></>)}
            <button
              className="inline-flex justify-center items-center py-2 px-4 opacity-100 bg-opacity-100 border border-transparent shadow-sm text-sm font-medium rounded focus:outline-none focus:ring-1 focus:ring-offset-2 disabled:opacity-50 text-white bg-blue-600 hover:bg-blue-700 disabled:hover:bg-blue-600 focus:ring-blue-600"
              disabled={loading || saving}
              onClick={renew}
            >
              Place Order
              <CheckBadgeIcon className="text-white w-5 h-5 ml-4"></CheckBadgeIcon>
            </button>
          </div>
          </>)}
        </div>
      </div>
      </>
    )
  }

  function FullCSALink() {
    return (
      <Link to="/csa/register/new" className="group">
        <div className="flex justify-between rounded bg-emerald-400 text-white hover:bg-emerald-500 font-bold px-3 py-2">
          <p>Sign up for a full CSA share</p>
          <ChevronDoubleRightIcon width="24" height="24" />
        </div>
      </Link>
    )
  }

  function bannerMessage(noMessage) {
    let title = "Vagabond Vege One Off Order";
    let message = (<></>);

    if (loaded && !noMessage) {
      if (view === "DETAILS") {
        message = (<h2 className="font-serif text-lg text-gray-700">Kia ora, register below for a one-off vege box before signing up for a full Vagabond Vege CSA.</h2>)
      } else {
        message = (
          <h2 className="font-serif text-lg text-gray-700"><b>Payment Details</b><br /> Thank you, your details have been saved. Please use the button below to complete your payment details.<br/><br/> <b>Note: no payments will be authorised until you have been accepted into the CSA, and you will recieve confirmation from GoCardless before any payments are taken.</b></h2>
        )
      }
    }

    return (
      <div className="w-full md:w-[700px] relative place-self-center">
        <h1 className="font-serif text-2xl font-bold text-emerald-600 mb-3">{title}</h1>
        {message}
        <br />
        {FullCSALink()}
      </div>
    )
  }

  if (success) {
    return successView()
  }

  return (
    <div className="absolute inset-0 pt-10 pb-5 px-5 bg-slate-100 overflow-scroll">
      {(loading || saving) ? (<div className="fixed top-0 w-full z-50"><div className="barLoader"></div></div>) : <></>}

      <div className="relative lg:fixed lg:left-10 lg:top-10">
        <img 
          src="https://cdn.vagabondvege.nz/images/logo/logo_main.png" 
          className="max-w-[200px]"
          alt="Vagabond Vege logo. Linocut vegetables and the farm name" />
      </div>

      <div className="grid grid-cols-1 gap-10">
        {bannerMessage()}

        {detailsAndTier()}

        <div className="w-full md:w-[700px] relative place-self-center flex items-center text-center flex-col py-1">
          <div className="w-5 h-auto">
            {Radicchio()}
          </div>
        </div>
        
      </div>
    </div>
  );
}